import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import styled from '@emotion/styled'

import I18n, { Trans } from '../i18n'
import AlertBox from '../components/AlertBox'
import Section from '../components/Section'
import Headline from '../components/Headline'

function ConfirmationNew({ flash }) {
  return (
    <Section mid css={{ minHeight: '100%' }}>
      <Section.Wrapper
        css={{ maxWidth: '32rem', marginTop: '3rem', marginBottom: '3rem' }}
      >
        <Helmet>
          <title>{I18n.t('confirmations.sent.headline')}</title>
        </Helmet>
        <Headline>
          <Trans id="confirmations.sent.headline" />
        </Headline>
        {flash.notice && (
          <AlertBox css={{ marginTop: '3rem' }}>{flash.notice}</AlertBox>
        )}
        <Link href="/login">
          {I18n.t('pages.login.title')}
        </Link>
      </Section.Wrapper>
    </Section>
  )
}

ConfirmationNew.propTypes = {
  flash: PropTypes.shape({
    notice: PropTypes.string
  })
}

const Link = styled.a`
  color: ${props => props.theme.chroma.base.hex()};
  font-size: 1rem;
  box-shadow: 0 1px 0 0 currentColor;
  align-self: center;
  margin-top: 2rem;
  @media (min-width: 480px) and (max-width: 679px) {
    font-size: 0.8rem;
  }
`

export default ConfirmationNew
